module.exports = __webpack_public_path__ + "img/playBtn.1bca3ac2.png";